import { InputSkeleton } from '@/_components';

import { SectionHeadingSkeleton } from '../../headers';
import PhoneNumberLoading from '../../inputs/phone-number/loading';
import { FormLayout } from '../../layout';

export function Loading() {
  return (
    <>
      <FormLayout>
        <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
      </FormLayout>
      <div className="mt-8 flex flex-col">
        <SectionHeadingSkeleton withRightSlot />
        <PhoneNumberLoading />
      </div>
    </>
  );
}
